import { InMemoryCache, DocumentNode } from '@apollo/client';
import { Injectable, inject } from '@angular/core';


export class GraphStateStore<T> {
  constructor(private cache: InMemoryCache, private query: DocumentNode, private key: string) {
  }

  currentState(): T {
    const queryResult = this.cache.readQuery<T>({ query: this.query });
    return (queryResult ? (queryResult as Record<string, unknown>)[this.key] : null) as T;
  }

  updateState(state: T) {
    this.cache.writeQuery({ query: this.query, data: { [this.key]: state }});
    // console.log('state change', state);
    return state;
  }
}

@Injectable({
  providedIn: 'root'
})
export class GraphStateService {
  private cache = inject(InMemoryCache);


  getStateStore<T>(query: DocumentNode, key: string) {
    return new GraphStateStore<T>(this.cache, query, key);
  }
}
